import { render, staticRenderFns } from "./UserModal.vue?vue&type=template&id=21765241&scoped=true&"
import script from "./UserModal.vue?vue&type=script&lang=js&"
export * from "./UserModal.vue?vue&type=script&lang=js&"
import style0 from "./UserModal.vue?vue&type=style&index=0&id=21765241&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21765241",
  null
  
)

export default component.exports